import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Register/Register.css";
import api from "../../services/api";
import Swal from "sweetalert2";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !password) {
      Swal.fire("Please fill in all fields.", "", "warning");
      return;
    }

    api
      .post("/auth/login", { email, password })
      .then((response) => {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));

        Swal.fire({
          icon: "success",
          title: "Login successful!",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => navigate("/"));
      })
      .catch((error) => {
        console.error("Login error:", error);
        Swal.fire(
          "Error!",
          error.response?.data?.message ||
            "Login failed. Please check your credentials.",
          "error"
        );
      });
  };

  return (
    <div className="register-background">
      <div className="register-overlay">
        <div className="register-container">
          <div className="register-form">
            <h2>Login</h2>
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type="email"
                  className="input-field"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="input-group">
                <input
                  type="password"
                  className="input-field"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="submit-btn">
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
